import React, { useEffect, useState, useCallback } from 'react';

import Axios from 'axios';
import { Nav } from 'react-bootstrap';

import { Select } from 'core/select/Select';

const DefaultPermissions = ['access_data', 'see_lookml_dashboards', 'see_user_dashboards', 'see_looks'];

const CustomPermissions = [
    {
        label: 'Explore',
        value: 'explore',
    },
    {
        label: 'Save',
        value: 'save_content',
    },
    {
        label: 'Download',
        value: 'download_without_limit',
    },
    {
        label: 'Schedule',
        value: `schedule_look_emails,schedule_external_look_emails`,
    },
    {
        label: 'Send',
        value: `send_outgoing_webhook,send_to_s3,send_to_sftp,send_to_integration`,
    },
    {
        label: 'create_table_calculations',
        value: 'create_table_calculations',
    },
    {
        label: 'see_sql',
        value: 'see_sql',
    },
    {
        label: 'see_drill_overlay',
        value: 'see_drill_overlay',
    },
    {
        label: 'embed_browse_spaces',
        value: 'embed_browse_spaces',
    },
    {
        label: 'embed_save_shared_space',
        value: 'embed_save_shared_space',
    },
];

enum Tab {
    Dashboard = '1',
    Look = '2',
    Explore = '3',
}

const getLookerParams = (type: Tab) => {
    const params = {
        embedUrl: '/embed/dashboards/2',
        models: ['mmna-poc'],
    };

    switch (type) {
        case Tab.Look:
            params.embedUrl = '/embed/looks/9';
            params.models = ['mmna_testing'];
            break;
        case Tab.Explore:
            params.embedUrl = '/embed/explore/mmna_testing/national_level';
            params.models = ['mmna_testing'];
            break;
        default:
            break;
    }
    return params;
};

export const Looker = () => {
    const [srcUrl, setSrcUrl] = useState('');
    const [permissions, setPermissions] = useState<string[]>([]);
    const [counter, setCountter] = useState(0);
    const [currentTab, setCurrentTab] = useState(Tab.Dashboard);

    const fetchLookerUrl = useCallback(async () => {
        const permArray: any = [];

        permissions.forEach((pItem: any) => {
            const values = pItem.value.split(',');

            values.forEach((vItem: any) => {
                permArray.push(vItem);
            });
        });
        const params = getLookerParams(currentTab);
        const {
            data: { url },
        } = await Axios.get(`/api/tenants/1990/looker-embed-url`, {
            params: {
                args: {
                    permissions: DefaultPermissions.concat(permArray),
                    ...params,
                },
            },
        });

        setSrcUrl(url);
        setCountter((c) => c + 1);
    }, [permissions, currentTab]);

    useEffect(() => {
        fetchLookerUrl();
    }, [currentTab]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="r4e-looker">
            <div
                style={{
                    padding: '20px',
                    width: '300px',
                }}
            >
                <h4>Permision</h4>
                <Select
                    isMulti
                    onMenuClose={fetchLookerUrl}
                    onChange={(selectedOptions: any, e: any) => {
                        setPermissions([...selectedOptions]);
                    }}
                    options={CustomPermissions}
                />
            </div>
            <Nav
                variant="pills"
                defaultActiveKey={Tab.Dashboard}
                style={{
                    margin: '0 10px',
                }}
                onSelect={(key) => {
                    setCurrentTab(key as any);
                }}
            >
                <Nav.Item>
                    <Nav.Link eventKey={Tab.Dashboard}>Dashboard</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey={Tab.Look}>Look</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey={Tab.Explore}>Explore</Nav.Link>
                </Nav.Item>
            </Nav>
            <div key={counter}>
                {srcUrl && (
                    <iframe
                        style={{
                            width: '100%',
                            height: '100vh',
                        }}
                        title="looker-iframe"
                        src={srcUrl}
                    />
                )}
            </div>
        </div>
    );
};
